module.exports = __webpack_public_path__ + "static/media/Yellow.946098b8.jpg";